"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TourDoorSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="m18 1 11 2.6c.6.1 1 .7 1 1.2v22c0 .5-.5 1.1-1 1.2l-11 2.6h-.2c-.5 0-.8-.3-.8-.8V17.367c-.363.093-.76.063-1.122-.114l-1.184-.626a3.13 3.13 0 0 1-1.63-1.878l-.266-.807-.909 3.483 2.36 2.513c.328.425.572.908.72 1.424l1.175 4.478a1.605 1.605 0 0 1-1.175 1.965 1.63 1.63 0 0 1-1.99-1.158l-.91-3.672a2.684 2.684 0 0 0-.72-1.432l-3.08-3.312a3.148 3.148 0 0 1-.72-2.95l.814-3.037L7 12.776c-.353.17-.64.454-.814.806l-.36.712a1.621 1.621 0 0 1-2.154.72c-.798-.428-.926-1.192-.712-2.144l.275-.72a4.89 4.89 0 0 1 2.53-2.325c.258-.098.5-.192.732-.282 1.48-.573 2.507-.97 4.072-.97h.112a2.574 2.574 0 0 1-.97-2 2.574 2.574 0 1 1 3.131 2.514 5.465 5.465 0 0 1 2.96 3.32l.454 1.432.745.397V1.8c0-.5.3-.8.8-.8h.2zm3 14.8c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1z" clip-rule="evenodd"></path><path d="M5.739 21.628a3.241 3.241 0 0 1-.721 1.073l-2.53 2.505a1.63 1.63 0 0 0 0 2.324 1.716 1.716 0 0 0 2.358 0l3.08-3.037c.29-.324.533-.688.72-1.08l.73-1.716a31.145 31.145 0 0 1-2.445-2.685c-.103.017-1.192 2.616-1.192 2.616z"></path></g>';
var TourDoorSVG = function TourDoorSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TourDoorSVG = TourDoorSVG;
TourDoorSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TourDoorSVG);
exports.default = _default;